export class MCLPopup {
    popup: HTMLDivElement;
    private id: string;
    private backdrop: HTMLDivElement;
    private closeBtn: HTMLButtonElement;
    private timeout: number | null = null;
    private hasYoutubeVideo: boolean = false;

    constructor(popup: HTMLDivElement) {
        this.popup = popup;
        this.backdrop = this.popup.querySelector('.mcl-popup__backdrop') as HTMLDivElement;
        this.closeBtn = this.popup.querySelector('.mcl-popup__close') as HTMLButtonElement;
        this.id = this.popup.getAttribute('id') as string;

        this.hasYoutubeVideo = this.popup.hasAttribute('data-yt-video');

        this.init();
        this.events();
    }

    private init = () => {
        // Init Code
    }

    private events = () => {
        this.backdrop.addEventListener('click', this.close);

        if (this.closeBtn) {
            this.closeBtn.addEventListener('click', this.close);
        }
    }

    open = (e: Event | undefined | null) => {
        if (e instanceof Event) {
            e.preventDefault();
        }

        document.documentElement.style.overflowY = 'hidden';
        this.popup.classList.add('mcl-popup--show');
        this.dispatchPopupEvent('opened');
        this.dispatchPopupEvent('opened', this.id);
        this.onPopupOpen();
    }

    private onPopupOpen = () => {
        if (this.hasYoutubeVideo) {
            this.playYoutubeVideo()
        }
    }

    close = (e: Event) => {
        if (e instanceof Event) {
            e.preventDefault();
        }

        this.popup.classList.add('mcl-popup--hide');

        if (this.timeout) clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
            document.documentElement.style.overflowY = 'auto';
            this.popup.classList.remove('mcl-popup--hide', 'mcl-popup--show');
            this.dispatchPopupEvent('closed');
            this.dispatchPopupEvent('closed', this.id);
            this.onPopupClose();
        }, 500);
    }

    private onPopupClose = () => {
        if (this.hasYoutubeVideo) {
            this.pauseYoutubeVideo();
        }
    }

    private dispatchPopupEvent(action: 'opened' | 'closed', id: string | null = null) {
        const eventName = id ? `mcl-popup:${id}:${action}` : `mcl-popup:${action}`;
        const event = new CustomEvent(eventName, {
            detail: {
                popupId: id,
                action: action,
                element: this.popup
            }
        });
        window.dispatchEvent(event);
    }

    private playYoutubeVideo = () => {
        const iframe = this.popup.querySelector('iframe') as HTMLIFrameElement;
        iframe.setAttribute('src', iframe.dataset.src as string);
    }

    private pauseYoutubeVideo = () => {
        const iframe = this.popup.querySelector('iframe') as HTMLIFrameElement;
        iframe.setAttribute('src', '');
    }
}

export const mclPopups = () => {
    const modals: NodeListOf<HTMLDivElement> = document.querySelectorAll('.mcl-popup');

    if (modals.length === 0) return;

    modals.forEach(popup => {
        const ID = popup.getAttribute('id');

        const triggers = document.querySelectorAll(`a[href="#${ID}"], [data-popup="${ID}"]`);
        const mclPopup = new MCLPopup(popup);

        triggers.forEach(trigger => trigger.addEventListener('click', mclPopup.open));
    });
}